import { useEffect, useRef, useState } from 'react'
export default function ContactForm() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [massage, setMassage] = useState("");

    const firstRef = useRef();
    const lastRef = useRef();
    const emailRef = useRef();
    const phoneRef = useRef();
    const massageRef = useRef();

    const validate = () => {
        if (firstName.length !== 0 && lastName.length !== 0 && massage.length !== 0 && email.length !== 0 && phone.length !== 0) {
            return true;
        } else if (firstName.length === 0) {
            console.log("firstname", firstName)
            firstRef.current.focus();
            return false;
        } else if (lastName.length === 0) {
            lastRef.current.focus();
            return false;
        } else if (email.length === 0) {
            emailRef.current.focus();
            return false;
        } else if (phone.length === 0) {
            phoneRef.current.focus();
            return false;
        } else if (massage.length === 0) {
            massageRef.current.focus();
            return false;
        }
    };

    const HandleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {

            try {
                const response = await fetch('https://api.web3forms.com/submit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        
                            subject : "SRP Contact Form new Submission ",
                            access_key  :'a37bc35f-e7f5-462b-96eb-2cc10eb2d099',
                            first_name : firstName,
                            last_name : lastName,
                            email : email,
                            phone: phone,
                            massage : massage
                        
                    }),
                });

                if (response.status === 200) {
                    handleClear()
                    alert('Form submitted successfully');
                } else {
                    alert('Form submission failed');
                }
            } catch (error) {
                alert('Error submitting form :', error);
            }
        }
    }

    const handleClear = () => {
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setMassage("");
      };
    return (
        <div className="contact-form col-md-6 float-left wow fadeInLeft">
            <form id="contact">
                <div className="d-flex">
                    <div className="form-group first-name">
                        <input type="text" value={firstName} className="form-control" id="con_name" name="firstName" onChange={(e) => setFirstName(e.target.value)} ref={firstRef} placeholder="First Name" />
                    </div>
                    <div className="form-group last-name">
                        <input type="text" value={lastName} className="form-control" ref={lastRef} id="con_lastname" name="con_lastname" onChange={(e) => setLastName(e.target.value)} placeholder="Last Name" />
                    </div>
                </div>
                <div className="form-group">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} ref={emailRef} className="form-control" id="con_email" name="con_email" aria-describedby="emailHelp" placeholder="Enter email" />
                </div>
                <div className="form-group">
                    <input type="number" value={phone} onChange={(e) => setPhone(e.target.value)} ref={phoneRef} className="form-control" id="con_mobile" name="con_mobile" placeholder="Mobile Number" pattern="/^-?\d+\.?\d*$/" onkeypress="if(this.value.length==10) return false;" />
                </div>
                <div className="form-group">
                    <textarea className="form-control" value={massage} onChange={(e) => setMassage(e.target.value)} ref={massageRef} rows="5" maxlength="200" id="con_message" name="con_message" placeholder="Your Message"></textarea>
                </div>
                <button type="buttton" onClick={HandleSubmit} name="" className="btn btn-primary contact">submit message</button>
                <div>
                    <p id="alert_msg" className="success_msg"></p>
                </div>
            </form>

        </div>
    )
}